import script from "./FreeExperienceView.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeExperienceView.vue?vue&type=script&setup=true&lang=js"

import "./FreeExperienceView.vue?vue&type=style&index=0&id=6fbf363c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbf363c"]])

export default __exports__